import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=88e06970&"
import script from "./UserSettings.vue?vue&type=script&lang=js&"
export * from "./UserSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cschwan/nextcloud/workspace/server/apps-extra/activity/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88e06970')) {
      api.createRecord('88e06970', component.options)
    } else {
      api.reload('88e06970', component.options)
    }
    module.hot.accept("./UserSettings.vue?vue&type=template&id=88e06970&", function () {
      api.rerender('88e06970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserSettings.vue"
export default component.exports